import { JSX } from "react";
import { AttestedEntity } from "./models/attestedEntity";
import QdpAttestationGroup from "./QdpAttestationGroup";
import QdpAttestationRow from "./QdpAttestationRow";
import QdpEntityGroup from "./QdpEntityGroup";

interface QdpAttestedEntityProps {
  entity: AttestedEntity;
  groupDepth: number;
  entityId: string;
  class: string;
  sourceId?: string;
  key?: number;
}

export default function QdpAttestedEntity(props: QdpAttestedEntityProps): JSX.Element {
  return (
    <>
      <li className="list-group-item bordered" data-toggle="collapse" data-target={`#${props.entityId}`}>
        <div className={props.class}>
          <span className="expandable">{props.entity?.Name}</span>
        </div>
      </li>
      <div className="collapse" id={props.entityId}>
        {props.entity?.AdditionalProperties &&
          Object.keys(props.entity.AdditionalProperties).map((key, index) => (
            <QdpAttestationRow row={{ RecordStatus: props.entity.AdditionalProperties[key], Value: key }} rowDepth={(props.groupDepth).toString()} key={index} />))
        }
        {props.entity &&
          props.entity.AttestationTypes.map((x, i) =>
            <QdpAttestationGroup entityXid={props.entity.Xid} attestation={x} key={i} groupDepth={props.groupDepth} sourceId={props.sourceId} />
          )}
        {props.entity.Locations &&
          <QdpEntityGroup entities={props.entity.Locations} dataId={`${props.entityId}-locations`} name="Locations" entityTag={`${props.entityId}`} groupDepth={props.groupDepth} index={props.key}/>}
      </div>
    </>
  );
}